<template>
  <div>
    <!-- fil d'ariane-->
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-10">
        <h2>Toutes les commandes</h2>
        <ol class="breadcrumb">
          <li>
            <a href="index.html">Accueil</a>
          </li>
          <li class="active">
            <strong> Liste des commandes</strong>
          </li>
        </ol>
      </div>
      <div class="col-lg-2">
      </div>
    </div>
    <!-- end fil d'ariane -->

    <div class="wrapper wrapper-content animated fadeInRight">
      <!-- barre de recherche -->
      <Accordion title="Rechercher" titleIcon="fa fa-search" :searchBarClassProp="true" :expandedProp="true">
        <template slot="content">
          <div class="row">
            <div class="col-lg-2">
              <div class="form-group input-bottom">
                <label class="control-label">
                  <select name="options"
                          class="form-control border-none"
                          v-model="filters.realm">
                    <option :value="null" selected>Entreprise</option>
                    <option v-for="(item, index) in suppliers"
                            :key="index"
                            :value="item">{{ item | capitalize }}</option>
                  </select>
                </label>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group input-bottom">
                <label class="control-label">
                  <select name="options"
                          class="form-control border-none"
                          v-model="filters.status">
                    <option :value="null" selected>Statut</option>
                    <option v-for="(item, index) in getOrderStatusList"
                            :key="index"
                            :value="item.id">{{ item.label }}</option>
                  </select>
                </label>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group input-bottom">
                <label class="control-label">
                  <select name="options"
                          class="form-control border-none"
                          v-model="filters.delivery">
                    <option :value="null">Livraison : non renseigné</option>
                    <option :value="true">Livraison : Oui</option>
                    <option :value="false">Livraison : Non</option>
                  </select>
                </label>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group input-bottom">
                <label class="control-label">
                  <select name="options"
                          class="form-control border-none"
                          v-model="filters.options">
                    <option :value="null">Options</option>
                    <option v-for="option in warrantyOptions"
                            :key="option.id"
                            :value="option.id">{{ option.name }}</option>
                  </select>
                </label>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group input-bottom">
                <label class="control-label">
                  <select class="form-control border-none"
                          v-model="filters.commercial">
                    <option :value="null"
                            selected>Commercial</option>
                    <option :key="null"
                            selected>N/A</option>
                    <option v-for="manager in accountManager"
                            :key="manager.id"
                            :value="manager.id">{{ manager.fullname }} </option>
                  </select>
                </label>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group input-bottom">
                <label class="control-label">
                  <select class="form-control border-none"
                          v-model="filters.team">
                    <option :value="null"
                            selected>Équipe</option>
                    <option v-for="team in getListTeams"
                            :key="team.id"
                            :value="team.id">{{ team.name }} </option>
                  </select>
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2">
              <div class="form-group input-bottom">
                <label class="control-label " for="creationrange">
                  <div id="creationrange" class="form-control label-calendar">
                    <i class="fa fa-calendar"></i>
                    <span>Date de création</span> <b class="caret"></b>
                  </div>
                </label>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group input-bottom">
                <label class="control-label " for="reportrange">
                  <div id="reportrange" class="form-control label-calendar">
                    <i class="fa fa-calendar"></i>
                    <span>Date de RDV/Livraison</span> <b class="caret"></b>
                  </div>
                </label>
              </div>
            </div>
            <div class="col-lg-2">
              <div class="form-group input-bottom">
                <label class="control-label">
                  <select name="options"
                          class="form-control border-none"
                          v-model="filters.transferStatus">
                    <option :value="null" selected>Statut Virement</option>
                    <option v-for="(item, index) in getTransferStatusList"
                            :key="index"
                            :value="item.id">{{ item.label }}</option>
                  </select>
                </label>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label class="control-label" for="search">
                  <input type="text"
                         id="search"
                         name="search"
                         placeholder="Rechercher"
                         class="form-control"
                         v-model="filters.search">
                </label>
              </div>
            </div>
          </div>
        </template>
      </Accordion>
      <!-- fin barre de recherche -->

      <!-- tableau liste des commandes -->
      <div class="row" :class="{ 'sk-loading': $apollo.queries.orderList.loading}">
        <div class="col-lg-12 mb20" v-if="$apollo.queries.orderList.loading">
          <spinner-three-bounce :displayNone="!$apollo.queries.orderList.loading"/>
          <div class="centerText">
            <h3>
              Veuillez patienter pendant le chargement de vos données.
            </h3>
          </div>
        </div>
        <div class="col-lg-12" v-if="!$apollo.queries.orderList.loading">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5><i class="fa fa-list"></i> Liste des commandes</h5>
              <div class="ibox-tools">
                <a class="collapse-link">
                  <i class="fa fa-chevron-up"></i>
                </a>
              </div>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-lg-8"/>
                <div class="col-lg-4">
                  <small class="pull-right input-bottom">
                    <label class="control-label label-per-page"><span>Par page</span>
                      <select name="perPage"
                              class="form-control select-per-page"
                              v-model="filters.per_page">
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                        <option :value="200">200</option>
                      </select>
                    </label>
                  </small>
                </div>
              </div>
              <div class="table-responsive m-t m-t-c">
                <table v-show="orderList.length"
                       class="table table-order table-hover table-striped dataTables-example">
                  <thead>
                  <tr>
                    <th>#</th>
                    <th>Crée&nbsp;le</th>
                    <th>Organisation</th>
                    <th class="w-100">Vendeur</th>
                    <th class="w-100">Acheteur</th>
                    <th class="w-150">Véhicule</th>
                    <th class="w-100">Cabinet</th>
                    <th class="text-center">RDV</th>
                    <th class="text-center">Livraison</th>
                    <th class="w-50">Options</th>
                    <th class="w-100">Commercial</th>
                    <th class="w-100">Statut</th>
                    <th class="w-100">Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in orderList"
                      :key="index">
                    <td>{{ item.id }}</td>
                    <td>{{ item.creationDate | formatDate }}</td>
                    <td><div class="label">{{ item.realm | capitalize }}</div></td>
                    <td>
                      <a :href="getCustomerUrl(getSeller(item))">{{ getSeller(item).firstname + ' ' + getSeller(item).lastname }}</a>
                      <small class="text-muted">
                        <br>{{ getSeller(item).phone }} <i class="fa fa-copy"></i>
                        <br>{{ getSeller(item).email }} <i class="fa fa-copy"></i>
                      </small>
                    </td>
                    <td>
                      <a :href="getCustomerUrl(getBuyer(item))">{{ getBuyer(item).firstname + ' ' + getBuyer(item).lastname }}</a>
                      <small class="text-muted">
                        <br>{{ getBuyer(item).phone }} <i class="fa fa-copy"></i>
                        <br>{{ getBuyer(item).email }} <i class="fa fa-copy"></i>
                      </small>
                    </td>
                    <td>
                      <a :href="getAdUrl(item)" target="_blank">{{ getVehicle(item).make + ' ' + getVehicle(item).model }}</a>
                    </td>
                    <td>{{ item.saleRdvCompany ? item.saleRdvCompany.name : '' }}</td>
                    <td class="text-center">
                      <router-link v-if="canCreateOrUpdateDisposal(item)"
                                   :to="`/command/${item.id}/cession`">
                        <template v-if="item.saleRdv && hasDisposalDate(item)">
                          <span class="pull-right"><i class="fa fa-pencil"></i></span>
                          <span class="rdvcession">
                            {{ item.saleRdv[0].date | formatDateTime }}
                          </span>
                        </template>
                        <button v-else
                                class="btn btn-success btn-xs"
                                type="button">
                          <i class="fa fa-calendar"></i>
                          <span class="bold">
                              <small>&nbsp;Créer le RDV</small>
                            </span>
                        </button>
                      </router-link>
                      <template v-else-if="!canCreateOrUpdateDisposal(item) && hasDisposalDate(item)">
                        {{ item.saleRdv[0].date | formatDateTime }}
                      </template>
                    </td>
                    <td class="text-center">
                      <router-link v-if="item.delivery && isCommandAlive(item)" :to="{ name: 'command-details-delivery-light', params: { id: item.id }}">
                        <template v-if="item.deliveryInfos && item.deliveryInfos.date">
                          <span class="pull-right"><i class="fa fa-pencil"></i></span>
                          <span class="rdvcession">
                            {{ item.deliveryInfos.date | formatDateTime }}
                           </span>
                        </template>
                        <button v-else
                                class="btn btn-success btn-xs"
                                type="button"><i class="fa fa-calendar"></i>
                          <span class="bold">
                          <small>&nbsp;Planifier la livraison</small>
                        </span>
                        </button>
                      </router-link>
                    </td>
                    <td>
                      <span v-if="isPremiumWarranty(item)"
                            class="label"
                            v-tooltip="{
                              content: item.options[0].name,
                              placement: 'bottom-center',
                              classes: ['tooltip-white']
                            }">
                        <i class="fa fa-wrench"></i>&nbsp;Garantie
                      </span>
                      <br v-if="item.options && item.delivery"/>
                      <span v-if="item.delivery"
                            class="label">
                        <i class="fa fa-flag-checkered" aria-hidden="true"></i>&nbsp;Livraison
                      </span>
                    </td>
                    <td>
                      <small>
                         <component-select :options="accountManager" :commandId="item.id" v-model="item.commercial"/>
                      </small>
                    </td>
                    <td>
                      <small>
                        <component-status
                          :status="item.status"
                          :sale-rdv-have-documents="item.saleRdvHaveDocuments"
                          :has-p2-p-transfer="item.hasP2PTransfer"
                        >
                        </component-status>
                      </small>
                    </td>
                    <td class="text-center">
                      <button type="button"
                              class="btn btn-xs btn-warning"
                              v-tooltip.bottom-start="'Modifier cette commande'"
                      >
                        <small>
                          <router-link :to="{ name: 'command-details-recapitulatif', params: { id: item.id }}">
                            <i class="fa fa-edit"></i>&nbsp;<span>Modifier</span>
                          </router-link>
                        </small>
                      </button>
                      <button type="button"
                              class="btn btn-xs btn-danger"
                              v-tooltip.bottom-start="'Annuler cette commande'"
                              @click="confirm('delete', item.id)"
                      >
                        <small>
                          <i class="fa fa-times"></i>&nbsp;&nbsp;<span>Annuler</span>
                        </small>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <td colspan="11" class="text-center">
                     <component-pagination v-if="totalPages"
                                           v-model="filters.page"
                                           :total-pages="totalPages"/>
                    </td>
                  </tr>
                  </tfoot>
                </table>
                <div v-if="!$apollo.loading && !orderList.length">
                  Aucune commande n'a été trouvée.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import NProgress from 'nprogress'

  import store from '../config/store'
  import CommercialList from '../api/query/CommercialList.gql'
  import PartnerList from '../api/query/PartnerList.gql'
  import WarrantyOptionList from '../api/query/WarrantyOptionList.gql'
  import TeamList from '../api/query/TeamList.gql'
  import StatusOptionList from '../api/query/StatusOptionList.gql'
  import TransferStatusOptionList from '../api/query/TransferStatusOptionList.gql'
  import Pagination from '../components/Pagination.vue'
  import Select from '../components/Select.vue'
  import moment from 'moment'
  import SpinnerThreeBounce from '@/components/spinners/SpinnerThreeBounce'
  import Status from "@/components/details/Status.vue"
  import Accordion from '@/components/accordion/accordion'

  export default {
    components: {
      'component-pagination': Pagination,
      'component-status': Status,
      'component-select': Select,
      SpinnerThreeBounce,
      Accordion
  },

    data: () => ({
      store,
      orderList: [],
      accountManager: [],
      warrantyOptions: [],
      getListTeams: [],
      pageChanged: true,
      kpiPeriod: 'month',
      filters: {
        page: 1,
        per_page: 50,
        search: '',
        creationDateMin: null,
        creationDateMax: null,
        dateMin: null,
        dateMax: null,
        realm: null,
        status: null,
        commercial: null,
        delivery: null,
        options: null,
        partner: null,
        transferStatus: null,
        team: null
      },
      suppliers: [
        'carizy',
        'heycar'
      ],
      selectedItemId: null
    }),

    computed: {
      filtersList () {
        return JSON.stringify(this.filters)
      },

      totalPages () {
        if (!this.orderList.length) {
          return 0
        }
        return parseInt(this.orderList[0].pageInfo.totalPages)
      }
    },

    watch: {
      'filtersList': function (newValue, oldValue) {
        if (JSON.parse(newValue).page === JSON.parse(oldValue).page) {
          this.pageChanged = false
        } else {
          this.pageChanged = true
          window.scrollTo(0, 0)
        }
      },

      '$apollo.loading': function () {
        if (!this.$apollo.loading) {
          store.loading = false
          NProgress.done()
        }
      }
    },

    mounted () {
      store.loading = true

      let ranges = ['creation', 'report'];
      ranges.forEach(range => {
        $('#' + range + 'range').daterangepicker({
          format: 'DD/MM/YYYY',
          locale: {
            applyLabel: 'Valider',
            cancelLabel: 'Annuler',
            fromLabel: 'Début',
            toLabel: 'Fin',
            daysOfWeek: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
            monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"],
            firstDay: 1
          }
        }, (start, end) => {

            this.filters[range === 'creation' ? 'creationDateMin' : 'dateMin'] = start.format('YYYY-MM-DD')
            this.filters[range === 'creation' ? 'creationDateMax' : 'dateMax'] = end.format('YYYY-MM-DD')
            moment.locale('fr')
            let formattedStart = moment(this.filters[range === 'creation' ? 'creationDateMin' : 'dateMin'], 'YYYY-MM-DD').format('DD MMMM YYYY')
            let formattedEnd = moment(this.filters[range === 'creation' ? 'creationDateMax' : 'dateMax'], 'YYYY-MM-DD').format('DD MMMM YYYY')
            $('#' + range + 'range span').html(formattedStart + ' - ' + formattedEnd);

            if (!$(".daterangepicker .range_inputs .clearBtn").length) {
              let self = this;
              let clearBtn = $('<button class="clearBtn btn btn-small btn-sm btn-warning" style="margin-top: 10px;">Effacer</button>');
              clearBtn.click(function() {
                let input = $('.label-calendar.active').attr('id');
                self.filters[input === 'creationrange' ? 'creationDateMin' : 'dateMin'] = null;
                self.filters[input === 'creationrange' ? 'creationDateMax' : 'dateMax'] = null;
                let placeholder = (input === 'creationrange') ? 'Date de Création' : 'Date de RDV/Livraison';
                $('#' + input + ' span').html(placeholder);
                $('.daterangepicker ').hide();
              });
              $(".daterangepicker .range_inputs").append(clearBtn);
            }
        });
      });

      this.$bus.$on('delete-confirm-success', this.onDeleteOrderConfirm)
      this.$bus.$on('nonSold-confirm-success', this.onNonSold)

    },
    destroyed () {
      this.$bus.$off('nonSold-confirm-success', this.onNonSold)
    },

    methods: {
      hasDisposalDate(item) {
        return item.saleRdv && item.saleRdv[0].date !== ""
      },

      canCreateOrUpdateDisposal(item) {
        if (item.delivery) {
          return false
        }

        if (!this.isCommandAlive(item)) {
          return false
        }

        return true
      },

      isPremiumWarranty (item) {
        return (item.options && [16, 17, 20, 21].includes(item.options [0].id));
      },

      commandListQuery () {
        let queries = []
        if (!this.pageChanged) {
          this.filters.page = 1
        }
        for (let key in this.filters) {
          if (this.filters[key] || typeof this.filters[key] === typeof true) {
            if (['search', 'commercial', 'creationDateMin', 'creationDateMax', 'dateMin', 'dateMax', 'realm', 'status', 'partner', 'transferStatus'].includes(key)) {
              queries.push(key + ': "' + this.filters[key] + '"')
            } else {
              queries.push(key + ': ' + this.filters[key])
            }
          }
        }
        return gql`
          { orderList (${queries.join(', ')}) {
            id
            creationDate
            adId
            realm
            hasP2PTransfer
            status {
              id
              label
              transferStatusId
              transferStatusLabel
            }
            delivery
            deliveryInfos {
              id
              date
            }
            commercial {
              id
              firstname
              lastname
            }
            options {
              name
            }
            seller {
              id
              firstname
              lastname
              email
              phone
            }
            buyer {
              id
              firstname
              lastname
              email
              phone
            }
            vehicule {
              id
              make
              model
              version
              color
              fuel
              licensePlate
              url
            }
            saleRdvHaveDocuments
            saleRdv {
              id
              date
            }
            saleRdvExpert {
              id
              name
            }
            pageInfo {
              totalPages
            }
          }
          }
        `
      },
      getSaleRdv (item) {
        return item.saleRdv[0]
      },

      getSeller (item) {
        return item.seller[0]
      },

      getBuyer (item) {
        return item.buyer[0]
      },

      getVehicle (item) {
        return item.vehicule[0]
      },

      getAdUrl (item) {
        return process.env.VUE_APP_BACKOFFICE_DOMAIN + process.env.VUE_APP_VEHICULES_EDIT + item.adId
      },

      getCustomerUrl (customer) {
        return process.env.VUE_APP_BACKOFFICE_DOMAIN + process.env.VUE_APP_CUSTOMER_EDIT + customer.id
      },

      isCommandCancelled (item) {
        return item.status.id == Status.constants.CANCELLED
      },

      isCommandFinished (item) {
        return item.status.id == Status.constants.SOLD
      },

      isCommandAlive(item) {
        if (this.isCommandCancelled(item)) {
          return false
        }

        if (this.isCommandFinished(item)) {
          return false
        }

        return true
      },

      deleteCommandQuery (itemId) {
        return gql`
        mutation {
          cancelOrder (orderId : ${itemId}){
            status
            result
          }
        }`
      },

      confirm (type, itemId) {
        this.selectedItemId = itemId
        let content = ''
        let validChildVue = 'confirm'
        if (type === 'delete') {
          content = 'Souhaitez-vous annuler cette commande ?'
          validChildVue = 'Reason'
          store.order.id = itemId
        }
        this.showModal({
          childVue: validChildVue,
          dataModel: {
            title: 'Êtes-vous sûr ?',
            content,
            type
          }
        })
      },
      addFullNameToAccountManager(manager) {
            manager.fullname = manager.firstname + ' ' + manager.lastname;

            return manager;
      },
      nonSold() {
        this.showModal({
          childVue: 'NonSold'
        })
      },
      onNonSold() {
        this.showModal({
          childVue: 'Reason'
        })
      },

      onDeleteOrderConfirm () {
        this.$apollo.mutate({
          mutation: this.deleteCommandQuery(this.selectedItemId)
        }).then(() => {
          this.showBanner('success', `Succès: la commande #${this.selectedItemId} a bien été annulée`)
          this.$apollo.queries.orderList.refetch()
        })
      }
    },

    apollo: {
      accountManager: {
        query: CommercialList,
        result({data}) {
          return data.accountManager.map(manager => this.addFullNameToAccountManager(manager));
        }
      },
      getListTeams: {
        query: TeamList,
      },
      warrantyOptions: {
        query: WarrantyOptionList
      },
      getOrderStatusList: {
        query: StatusOptionList
      },
      getTransferStatusList: {
        query: TransferStatusOptionList
      },
      orderList: {
        query () {
          return this.commandListQuery()
        },
        result ({ data, loading, networkStatus }) {
          this.orderList = data.orderList.map(order => {
            order.commercial = this.addFullNameToAccountManager(order.commercial);
            return order;
          });
          setTimeout(function(){
            if ( $.fn.dataTable.isDataTable( '.dataTables-example' ) ) {
              $('.dataTables-example').DataTable();
            } else {
              $('.dataTables-example').DataTable({
                "retrieve": true,
                "paging": false,
                "info": false,
                "searching": false,
                "order": [[ 0, "desc" ]]
              });
            }
          }, 3000);
        },
      }
    }
  }
</script>
